import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReportSectionCTACard } from 'components/shared/ReportSectionCTACard';
import ValueForecasterIllustration from 'images/value-forecaster/value-forecaster.svg';

export const ValueForecasterCTA = () => {
  const navigate = useNavigate();
  const { trackEventGA4 } = useContext(AppConfig);

  const handleForecastValueClick = useCallback(() => {
    trackEventGA4({
      event_name: 'cta_click',
      type: 'view value forecaster',
    });
    navigate('/bumper-chat/chat/value-forecaster');
  }, [navigate, trackEventGA4]);

  return (
    <ReportSectionCTACard
      id="value-forecaster-cta"
      headline="Get a Vehicle Value Forecast"
      bodyText="See how your car’s value may change over the next 3 years."
      buttonText="Forecast Value"
      onButtonClick={handleForecastValueClick}
      illustration={{
        src: ValueForecasterIllustration,
        alt: 'Value forecaster preview showing a sample analysis result',
      }}
      dataTestId="value-forecaster-cta"
    />
  );
};
